import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import { approveOrRejectOrderAPI, bulkStatusUpdateAPI, fetchConsignedOrderAPI, getAllOrderStatusesAPI, getAllPaymentTermsAPI, getConsignedOrderByIdAPI, getDistributorOptionsAPI, getOrdersPuzzleAPI, getPartnersAPI, getProductOptionsAPI, saveConsignedOrderAPI, sendOrderToPuzzleAPI, updateOrderStatusAPI } from "./endpoints";


function* getConsignedOrderSaga(action) {
  try {
    yield put(actions.setConsignedOrderLoader(true));
    const _api = yield call(fetchConsignedOrderAPI, action.payload);
    yield put(actions.setConsignedOrder(_api.data.results));
    yield put(actions.setConsignedOrderLoader(false));
    yield put(actions.setEditConsignedOrderLoader(false));
  } catch (error) {
    yield put(actions.setConsignedOrderLoader(false));
    console.log(error);
  }
}

function* getConsignedOrderByIdSaga(action) {
  try {
    yield put(actions.setEditConsignedOrderLoader(true));
    const _api = yield call(getConsignedOrderByIdAPI, action.payload);
    yield put(actions.setConsignedOrderById(_api.data.results));
    yield put(actions.setEditConsignedOrderLoader(false));
    yield put(actions.setEditConsignedOrderLoader(false));
  } catch (error) {
    yield put(actions.setEditConsignedOrderLoader(false));
    console.log(error);
  }
}

function* getProductOptionsSaga(action) {
  try {
    yield put(actions.setEditConsignedOrderLoader(true));
    const _api = yield call(getProductOptionsAPI, action.payload);
    yield put(actions.setProductOptions(_api.data.results));
    yield put(actions.setEditConsignedOrderLoader(false));
  } catch (error) {
    yield put(actions.setEditConsignedOrderLoader(false));
    console.log(error);
  }
}

function* getPartnersSaga(action) {
  try {
    const _api = yield call(getDistributorOptionsAPI, action.payload);
    yield put(actions.setPartners(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getOrderStatusesSaga(action) {
  try {
    const _api = yield call(getAllOrderStatusesAPI, action.payload);
    yield put(actions.setOrderStatuses(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getPaymentTermOptionsSaga(action) {
  try {
    const _api = yield call(getAllPaymentTermsAPI, action.payload);
    yield put(actions.setPaymnentTermOptions(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* approveRejectOrderSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(approveOrRejectOrderAPI, action.payload?.payload);
    // yield put(actions.setPaymnentTermOptions(_api.data.results));
    if (_api?.data?.success) {
      yield put(actions.getConsignedOrder(action.payload?.filters || {}));
      yield put(
        commonActions.setAlert({
          message: _api?.data?.message,
          alertType: "success",
          showToast: true,
        })
      );
      yield put(commonActions.setLoading(false));
    }
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* sendOrdersToPuzzleSaga(action) {
  try {
    // yield put(actions.setPuzzleLoader(true));
    const _api = yield call(sendOrderToPuzzleAPI, action.payload);
    if (_api?.data?.success) {
      yield put(actions.setPuzzleLoader(false));
      yield put(actions.getConsignedOrder(action.payload || {}));
      yield put(
        commonActions.setAlert({
          message: "Sync Performed",
          alertType: "success",
          showToast: true,
        })
      );
    }
  } catch (error) {
    yield put(actions.setPuzzleLoader(false));
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || error.message || "Sync Failed",
        alertType: "error",
        showToast: true,
      })
    );
    console.log(error);
  }
}

function* getOrdersPuzzleSaga(action) {
  try {
    yield put(actions.setPuzzleLoader(true));
    const _api = yield call(getOrdersPuzzleAPI, action.payload);
    if (_api?.data?.success) {
      yield put(actions.sendOrderToPuzzle(action.payload || {}));
    } else {
      yield put(actions.setPuzzleLoader(false));
      yield put(
        commonActions.setAlert({
          message: _api?.data.message || "Sync Failed",
          alertType: "error",
          showToast: true,
        })
      );
    }
  } catch (error) {
    console.log(error?.response?.data?.message);
    yield put(actions.setPuzzleLoader(false));
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || error.message || "Sync Failed",
        alertType: "error",
        showToast: true,
      })
    );
  }
}

function* saveConsignedOrderSaga(action) {
  try {
    yield put(actions.setEditConsignedOrderLoader(true));
    const _api = yield call(saveConsignedOrderAPI, action.payload);
    if (_api?.data?.success) {
      yield put(actions.getConsignedOrder(action?.payload?.filters || {}));
      yield put(
        commonActions.setAlert({
          message: "Consigned Order Saved Successfully",
          alertType: "success",
          showToast: true,
        })
      );
    }
  } catch (error) {
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || error.message || "Save Order Failed",
        alertType: "error",
        showToast: true,
      })
    );
    yield put(actions.setEditConsignedOrderLoader(false));
    console.log(error);
  }
}

function* updateOrderStatusSaga(action) {
  try {
    yield put(actions.setEditConsignedOrderLoader(true));
    const _api = yield call(updateOrderStatusAPI, action.payload);
    if (_api?.data?.success) {
      yield put(actions.getConsignedOrder(action?.payload?.filters || {}));
    }
  } catch (error) {
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || error.message || "Update Order Status Failed",
        alertType: "error",
        showToast: true,
      })
    );
    yield put(actions.setEditConsignedOrderLoader(false));
    console.log(error);
  }
}

function* bulkStatusUpdateSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(bulkStatusUpdateAPI, action.payload?.payload);
    // yield put(actions.setPaymnentTermOptions(_api.data.results));
    if (_api?.data?.success) {
      yield put(actions.getConsignedOrder(action.payload?.filters || {}));
      yield put(
        commonActions.setAlert({
          message: "Order Status Updated Successfully",
          alertType: "success",
          showToast: true,
        })
      );
      yield put(commonActions.setLoading(false));
    }
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || error.message || "Update Order Status Failed",
        alertType: "error",
        showToast: true,
      })
    );
  }
}

export function* withConsignedOrderSaga() {
  yield all([
    takeEvery(actionTypes.GET_CONSIGNED_ORDER, getConsignedOrderSaga),
    takeEvery(actionTypes.GET_CO_BY_ID, getConsignedOrderByIdSaga),
    takeEvery(actionTypes.GET_PRODUCT_OPTIONS, getProductOptionsSaga),
    takeEvery(actionTypes.GET_CONSIGNED_PARTNERS, getPartnersSaga),
    takeEvery(actionTypes.GET_ORDER_STATUS, getOrderStatusesSaga),
    takeEvery(actionTypes.GET_PAYMENTTERM_OPTIONS, getPaymentTermOptionsSaga),
    takeEvery(actionTypes.APPROVE_REJECT_ORDER, approveRejectOrderSaga),
    takeEvery(actionTypes.SEND_ORDER_TO_PUZZLE, sendOrdersToPuzzleSaga),
    takeEvery(actionTypes.GET_ORDERS_PUZZLE, getOrdersPuzzleSaga),
    takeEvery(actionTypes.SAVE_CONSIGNED_ORDER, saveConsignedOrderSaga),
    takeEvery(actionTypes.UPDATE_ORDER_STATUS, updateOrderStatusSaga),
    takeEvery(actionTypes.BULK_STATUS_UPDATE, bulkStatusUpdateSaga),
  ]);
}
